import * as React from 'react';
import { cn } from '../lib/cn';

// Headline tile (prototype A-01 / K-01): the figure first in Montserrat, the label under it, an optional note (red when
// something needs attention, e.g. "1 overdue"). `labelFirst` is the reports layout (P-C10): a coloured uppercase label
// with its icon above the figure, the note below; `selected` gives the tile the dark border (the "Total" tile).
type Tone = 'ink' | 'ok' | 'warn' | 'bad';
const TONE: Record<Tone, string> = { ink: 'text-ink', ok: 'text-ok', warn: 'text-warn', bad: 'text-bad' };

export function KpiTile({ value, label, note, noteTone, compact = false, labelFirst = false, tone = 'ink', icon, selected = false, className }: {
  value: React.ReactNode; label: React.ReactNode; note?: React.ReactNode; noteTone?: 'bad' | 'muted';
  /** Long figures (full money amounts, never rounded): a smaller size on one line. */
  compact?: boolean; labelFirst?: boolean; tone?: Tone; icon?: React.ReactNode; selected?: boolean; className?: string;
}) {
  const figure = <p className={cn('font-display font-bold tabular', TONE[tone], compact ? 'whitespace-nowrap text-lg leading-8' : 'text-[26px] leading-8')}>{value}</p>;
  return (
    <div className={cn('rounded-card border bg-surface p-4 shadow-card', selected ? 'border-ink' : 'border-line', className)}>
      {labelFirst ? (
        <>
          <p className={cn('flex items-center gap-1 text-xs font-semibold uppercase tracking-wide', TONE[tone])}>{icon}{label}</p>
          <div className="mt-1">{figure}</div>
        </>
      ) : (
        <>{figure}<p className="mt-1 text-[13px] text-ink-2">{label}</p></>
      )}
      {note && <p className={cn('mt-1 text-xs', noteTone === 'bad' ? 'font-semibold text-bad' : 'text-ink-3')}>{note}</p>}
    </div>
  );
}
